import { c as a } from "../../../../index.esm-BeDSGXP5.js";
import { css as r } from "styled-components";
const s = {
  informationWrapper: ({ theme: o }) => /* @__PURE__ */ r([
    "border-radius:0.2rem;",
    ""
  ], a({
    backgroundColor: o.componentColors.cookieModal.informationBackgroundColor,
    padding: o.space.sm,
    marginBottom: o.space.sm
  })),
  roundedModalContentWrapper: () => /* @__PURE__ */ r([
    "border-radius:0.5rem;max-width:100rem;"
  ])
};
export {
  s as default
};
